import { TestimonialPageSection } from "../../models/page-builder/testimonial-page-section.model";
import { HTMLCodePageSection } from "../../models/page-builder/html-code-section.model";

export const MOCK_PAGE_HTML_CODE_SECTION: HTMLCodePageSection = {
  type: "html-code-section",
  content: {
    htmlCode: `
    <div class="container">
      <h1>HTML Code Section</h1>
      <p>This is a mock HTML code section</p>
    </div>
    `,
    cssCode: `
    .container {
      background-color: #f1f1f1;
      padding: 20px;
      margin: 20px;
      border-radius: 5px;
    }
    `,
  },
  design: {
    layout: {
      blockStyle: "plain",
      blockAlignment: "center",
    },
    appearance: {
      backgroundColor: "#ffffff",
      cardBackgroundColor: "#ffffff",
      backgroundImage: {
        type: "image",
        originalFileName: "background-original",
        uploadFileName: "background.Mp4",
        url: "",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.1,
          blending: "normal",
          blur: 2,
          grayScale: 10,
          contrast: 100,
        },
      },
    },
  },
};

